import React from 'react';
import SignatureCanvas from 'react-signature-canvas';
import handleChange from './utils/handleChange';

export const SignaturePad = ({ formData, setFormData, showError, investorType }) => {
  const sigPadRef = React.useRef();
  const [touched, setTouched] = React.useState(false);

  const getTargetSignatureField = () => {
  const type = formData.investorType;

  if (type === 'revocableGrantorTrust' || type === 'selfDirectedIRA') {
    return "signatureEntityInd";
  }

  if (formData.subscriberName && formData.subscriberName.trim() !== "") {
    return "signature";
  }

  if (formData.subscriberNameEntityInd && formData.subscriberNameEntityInd.trim() !== "") {
    return "signatureEntityInd";
  }

  return "signature";
};

  const updateSignature = () => {
    const fieldName = getTargetSignatureField();
    setTouched(true);
    if (sigPadRef.current && !sigPadRef.current.isEmpty()) {
      const signatureImage = sigPadRef.current.getTrimmedCanvas().toDataURL('image/png');
      handleChange({ name: fieldName, value: signatureImage }, setFormData);
    } else {
      handleChange({ name: fieldName, value: "" }, setFormData);
    }
  };

  const clearSignature = () => {
    if (sigPadRef.current) {
      sigPadRef.current.clear();
      updateSignature();
    }
  };

  const isSignatureEmpty = sigPadRef.current?.isEmpty?.() ?? true;
  const shouldShowError = showError && isSignatureEmpty;

  return (
    <div style={{ textAlign: 'left' }} id="signatureScrollAnchor" name="signature">
    <h2>{formData.investorType === 'jointSpouse' ? 'Spouse 1 Signature' : 'Signature'}</h2>
      <SignatureCanvas
        penColor="black"
        canvasProps={{
          width: 500,
          height: 85,
          className: 'sigCanvas',
          style: {
            border: shouldShowError ? '2px solid red' : '1px solid #333',
            borderRadius: '4px'
          }
        }}
        ref={sigPadRef}
        onEnd={updateSignature}
      />

      <div style={{ marginTop: '5px' }}>
        <button type="button" onClick={clearSignature}>
          Clear Signature
        </button>
        {shouldShowError && (
          <div style={{ color: 'red', marginTop: '4px' }}>
            Signature is required.
          </div>
        )}
      </div>
    </div>
  );
};
